import { __decorate, __metadata } from "tslib";
import { Serialize } from '@ftr/serialization';
import { YearMonth } from '@js-joda/core';
/**
 * A count of recordings on the specified date
 */
export class CountByMonth {
    /**
     * @param yearMonth The date on which the recording was made
     * @param count The number of recordings
     */
    constructor(yearMonth, count) {
        this.count = count;
        this.yearMonth = yearMonth;
    }
}
__decorate([
    Serialize(),
    __metadata("design:type", YearMonth
    /**
     * @param yearMonth The date on which the recording was made
     * @param count The number of recordings
     */
    )
], CountByMonth.prototype, "yearMonth", void 0);
